import { jsx } from 'react/jsx-runtime';
import DividerStyles from './Divider3.js';

const Divider = ({ className }) => {
    return jsx("div", { className: DividerStyles.dividerStyle(className) });
};

export { Divider };
